module.exports = __webpack_public_path__ + "img/new_label.df51b2c6.svg";